export default __webpack_public_path__ + "61a44da1457a4eddefccc5c0745f3765.png";